import React from 'react';
import { NumericFormat } from 'react-number-format';

interface NumberFormatCustomProps {
  inputRef: (instance: typeof NumericFormat | null) => void;
  // inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  type: string;
}

export function NumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      // workaround puse tel para quitar las flechas del input
      type="tel"
      allowLeadingZeros={props.type === 'number' ? true : false}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          ...other,
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      valueIsNumericString
    />
  );
}
